import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[length-warning]'
})
export class LengthWarningDirective implements OnInit {
  @Input('length-warning') targetLength: string;

  private warningEl: HTMLElement;

  constructor (
    private el      : ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit () : void {
    this.warningEl = this.renderer.createElement('small');

    this.renderer.addClass(this.warningEl, 'text-warning');
    this.renderer.setStyle(this.warningEl, 'display', 'none');

    this.renderer.appendChild(
      this.el.nativeElement.parentElement,
      this.warningEl
    );
  }

  @HostListener('input')
  onInput () : void {
    const value  = this.el.nativeElement.value || '';
    const target = parseInt(this.targetLength, 10);

    if ( value.length > 0 && value.length !== target ) {
      this.warningEl.textContent = `${ value.length } / ${ target }`;

      this.renderer.setStyle(this.warningEl, 'display', 'block');
    }
    else {
      this.renderer.setStyle(this.warningEl, 'display', 'none');
    }
  }
}
